export const MOVE_TO_NEXT_STEP = "MOVE_TO_NEXT_STEP";
export const MOVE_TO_PREVIOUS_STEP = "MOVE_TO_PREVIOUS_STEP";
export const SET_REPORT_ID = "SET_REPORT_ID";
export const RESET_REPORT_STEPPER = "RESET_REPORT_STEPPER";
export const MOVE_TO_SPECIFIC_STEP = "MOVE_TO_SPECIFIC_STEP";
export const SET_REPORT_NAME = "SET_REPORT_NAME";
export const SET_REGION_COLUMNS = "SET_REGION_COLUMNS";
